import React from 'react'
import { ClickAwayListener, Popper } from '@mui/material'
import { useUserAPI } from '../../../providers/UserAPIProvider'

import DownArrowIcon from '../../icons/DownArrowIcon'
import Search from '../Search'
import CloseIcon from './CloseIcon'
import MediaAvatar from '../../atoms/MediaAvatar'

import useStyles from './styles'

const ConverstationParticipantRow = ({ userId, classes }) => {
  const { allUsers, loadUser } = useUserAPI()
  const user = allUsers[userId]
  React.useEffect(() => {
    if (!allUsers[userId]) {
      loadUser(userId)
    }
  }, [allUsers, loadUser, userId])

  return (
    <React.Fragment>
      <MediaAvatar className={classes.participantAvatar} user={user} />
      <label>{user?.name || 'Loading...'}</label>
    </React.Fragment>
  )
}

const ConversationParticipants = ({ participants, fullParticipants }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [search, setSearch] = React.useState('')
  const open = React.useMemo(() => Boolean(anchorEl), [anchorEl])
  const mainRef = React.useRef()
  const filteredParticipants = React.useMemo(
    () => fullParticipants?.filter(x => participants.some(y => y === x.id)),
    [fullParticipants, participants]
  )
  const [result, setResults] = React.useState(filteredParticipants)

  const classes = useStyles()

  React.useEffect(() => {
    const searchVal = search
    if (searchVal.length > 1) {
      const filtered = [...filteredParticipants].filter(item =>
        item.name.toLowerCase().includes(searchVal)
      )
      setResults(filtered)
    } else if (searchVal.length === 0) {
      setResults(filteredParticipants)
    }
  }, [search, filteredParticipants])

  // Opens menu
  const handleClick = React.useCallback(e => {
    const target = e.currentTarget
    setAnchorEl(old => (old ? null : target))
  }, [])

  // Closes menu and resets state
  const handleClose = React.useCallback(() => {
    setAnchorEl(null)
  }, [])

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <div ref={mainRef} onClick={handleClick} className={classes.root}>
          <DownArrowIcon />
        </div>
        {open && (
          <Popper
            open={open}
            anchorEl={anchorEl}
            style={{ zIndex: '1500' }}
            placement='bottom-start'
          >
            <div className={classes.menu}>
              <div className={classes.header}>
                <label className={classes.headerTitle}>Participants</label>
                <CloseIcon onClick={handleClose} />
              </div>
              <Search
                placeholder='Search participant...'
                value={search}
                onChange={e => setSearch(e.target.value)}
                maxLength={20}
                className={classes.search}
              />
              <section className={classes.resultsSection}>
                {result.length > 0 ? (
                  <>
                    {result.map((item, i) => {
                      return (
                        <div
                          key={`${item.id}${i + 1}`}
                          className={classes.items}
                        >
                          <ConverstationParticipantRow
                            userId={item.id}
                            classes={classes}
                          />
                        </div>
                      )
                    })}
                  </>
                ) : (
                  <div>No results</div>
                )}
              </section>
            </div>
          </Popper>
        )}
      </div>
    </ClickAwayListener>
  )
}

export default ConversationParticipants
